import React from 'react';
interface GlowNumberProps {
  value: string;
  size?: 'lg' | 'md';
}
export function GlowNumber({
  value,
  size = 'lg'
}: GlowNumberProps) {
  return <div className="relative flex items-center justify-center" data-id="element-37" data-mp="o8mdn00iutz3">
      <span aria-hidden="true" className="aura-pulse absolute h-40 w-40 rounded-full" style={{
      background: 'radial-gradient(circle, rgba(139,92,246,0.42) 0%, rgba(5,6,15,0) 70%)'
    }} data-id="element-38" data-mp="jaks88fmiikg" />
      <span aria-hidden="true" className="absolute h-52 w-52 rounded-full border border-aura/20" style={{
      boxShadow: 'inset 0 0 40px -18px rgba(167,139,250,0.6)'
    }} data-id="element-39" data-mp="9f107x46k40z" />
      <span className={['number-glow relative font-sans font-light tabular-nums tracking-tight text-white', size === 'lg' ? 'text-[68px] leading-none' : 'text-[44px] leading-none'].join(' ')} data-id="element-40" data-mp="lnzwa3se04v">
        {value}
      </span>
    </div>;
}